// @flow
import * as React from 'react';

import { useRouter } from 'Client/router/useRouter';
import ReactAppContext from 'Context/ReactAppContext';
import legacyOpener from 'Utils/legacy-booking-engine/legacyOpener';
import BookingEngineFormContainer from 'Components/widgets/booking-engine-form/BookingEngineForm.container';
import { type BookingRedirectParams } from 'Components/widgets/booking-engine-form/BookingEngineForm';

import {
  getBookingConfig,
  getLegacyResortRedirectUrl,
  type ProductBookingLineProps,
} from './ProductBookingLine.utils';

export const ProductBookingLine = (props: ProductBookingLineProps) => {
  const appContext = React.useContext(ReactAppContext);
  const { location } = useRouter<UrlParams, QueryParams>();
  if (!props.resort) {
    return null;
  }
  const goToLegacyBookingEngine = (
    bookingParams: BookingRedirectParams,
    birthdayDateFormat: string,
  ) => {
    legacyOpener.openLegacy(appContext, bookingParams, birthdayDateFormat);
  };
  const bookingConfig = getBookingConfig(props);
  const legacyResortRedirect = getLegacyResortRedirectUrl(location);
  return (
    <div className="Line Line-BookingEngine">
      <div className="PriceTicket-sticky-beacon" />
      <BookingEngineFormContainer
        bookingConfig={bookingConfig.booking}
        bookingCriteria={props.bookingCriteria}
        checkPriceLabel={props.checkPriceLabel}
        config={bookingConfig}
        cmsPrice={bookingConfig.price}
        cmsStartingPrice={bookingConfig.resort.startingPrice}
        enableTransfer={props.enableTransfer}
        goToLegacyBookingEngine={goToLegacyBookingEngine}
        i18n={{
          ...bookingConfig,
          package: props.package,
          checkPriceLabel: props.checkPriceLabel,
          errorMessageNoProposal: props.package.errorMessageNoProposal,
          errorMessageNoMorePackages: props.package.errorMessageNoMorePackages,
          legalInformations: props.legalInformations,
        }}
        legacyResortRedirect={legacyResortRedirect}
        legalInformations={props.legalInformations}
        location={location}
        package={props.package}
        pushImage={
          bookingConfig.booking.form.pushImage ? bookingConfig.booking.form.pushImage : null
        }
        resort={props.resort}
        resortId={props.resortId}
        travelAdvisorConfig={bookingConfig.travelAdvisor}
      />
    </div>
  );
};
